export default [{
  path: '/follow-up-by-board/:profileId/:profile',
  name: 'FollowUpByBoard',
  component: () => import('./FollowUpByBoard'),
  meta: {
    resource: 'dashboard',
    actions: ['read']
  }
}]
